import { AfterContentInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { finalize } from 'rxjs/operators';

import { DynamicDocumentService, ErrorHandlerService, TemplateService } from '@app/services';
import { CustomSlimTemplate, SlimDynamicTemplate, SlimTemplate } from '@app/models';
import { Observable } from 'rxjs';

export type ModalResult = CustomSlimTemplate;
export interface ModalPublicProperties {
  template: CustomSlimTemplate;
}

@Component({
  selector: 'app-duplicate-template-modal',
  templateUrl: './duplicate-template-modal.component.html',
  styleUrls: ['./duplicate-template-modal.component.scss'],
  standalone: false
})
export class DuplicateTemplateModalComponent implements ModalPublicProperties, AfterContentInit {
  @Input() template: CustomSlimTemplate;
  form!: UntypedFormGroup;
  isLoading = false;
  @ViewChild('nameInput', { static: false }) private nameInput: ElementRef<HTMLInputElement>;

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: UntypedFormBuilder,
    private templateService: TemplateService,
    private dynamicDocumentService: DynamicDocumentService,
    private errorHandlerService: ErrorHandlerService
  ) {
    this.form = this.formBuilder.group({ template: this.formBuilder.group({ name: '' }) });
  }

  ngAfterContentInit() {
    this.form.get('template.name').setValue(this.template.name || '');
    setTimeout(() => this.nameInput.nativeElement.focus());
  }

  duplicate() {
    this.isLoading = true;
    this.form.markAllAsTouched();

    const templateId = this.template.id;
    const name = this.form.get('template.name').value;
    const template$: Observable<SlimDynamicTemplate | SlimTemplate> = this.template?.is_dynamic_template
      ? this.dynamicDocumentService.duplicate(templateId, name)
      : this.templateService.duplicate(templateId, name);

    template$.pipe(finalize(() => (this.isLoading = false))).subscribe({
      next: data => this.modal.close(data as ModalResult),
      error: error => this.errorHandlerService.handleValidation(this.form, error)
    });
  }
}
